export default val => {
  document.querySelector('.CodeMirror').CodeMirror.setValue(val);
};
// Little dirty solution.